// Recovered compiled webpack factory 86048. Edit this function expression; run npm run build.
// Keep page composition exports while retiring the upstream marketing/navigation/newsletter shell.
(module, exports, require) => {
  "use strict";
  require.r(exports);
  require.d(exports, {
    Detail: () => Detail, Display: () => Display, Eyebrow: () => Eyebrow,
    Heading: () => Heading, Lede: () => Lede, MarketingShell: () => StudioShell,
  });
  const jsx = require(95155);
  const text = (tag, classes) => ({ children, className = "" } = {}) =>
    jsx.jsx(tag, { className: classes + " " + className, children });
  const Detail = text("span", "block text-sm");
  const Display = text("h1", "text-4xl font-medium");
  const Eyebrow = text("p", "text-sm uppercase tracking-wide");
  const Heading = text("h2", "text-3xl font-medium");
  const Lede = text("p", "text-lg");
  function StudioShell({ children } = {}) {
    return jsx.jsxs("div", { children: [
      jsx.jsx("header", { className: "px-6 py-5", children:
        jsx.jsx("a", { href: "/editor", className: "font-medium", children: "Mockup Studio" }) }),
      jsx.jsx("main", { children }),
    ] });
  }
}
